import { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import ConfirmModal from "../../../global/components/ConfirmModal";
import usePost from "../../../global/hooks/usePost";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import { convertToUnix } from "../../../global/utils/unixToLocalTime";
import { formatYearMonthToLabel } from "../../../global/utils/unixToLocalTime";
import { InvoiceColumns } from "./Column";
import { InvoiceFilter } from "../Components/FilterComponent";
import useDelete from "../../../global/hooks/useDelete";
import CommonButton from "../../../global/components/CommonButton";
import { VscServerProcess } from "react-icons/vsc";
import {
  ClockCircleFilled,
  FileTextFilled,
  WarningFilled,
} from "@ant-design/icons";
import { getUserRole } from "../../../global/hooks/getUserRole";
import dayjs from "dayjs";
import axios from "axios";
import {
  downloadInvoiceRegisterPDF,
  printInvoiceRegisterPDF,
} from "../utils/downloadInvoicePdf";
import "./Invoice.css";

const initialFilterState = {
  InvoiceNo: "",
  OemNo: "",
  DealerNo: "",
  InvoiceTime: "",
  Month: "",
  Paid: "",
  PaymentStatus: "",
};

const formatMoney = (value) => {
  const amount = Number(value || 0);
  return `$${amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const PAYMENT_MIX = [
  { key: "paid", label: "Paid", color: "#0F6E56" },
  { key: "unpaid", label: "Unpaid", color: "#003DD3" },
  { key: "overdue", label: "Overdue", color: "#9A3324" },
];

const PaymentPerformanceCircle = ({
  paid = 0,
  unpaid = 0,
  overdue = 0,
  onSelect,
}) => {
  const counts = { paid, unpaid, overdue };
  const total = paid + unpaid + overdue;
  const radius = 32;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;
  const collected = total ? Math.round((paid / total) * 100) : 0;

  return (
    <div className="invoice-mix-wrap">
      <div className="invoice-mix-ring" aria-hidden>
        <svg viewBox="0 0 84 84">
          <circle
            cx="42"
            cy="42"
            r={radius}
            fill="none"
            stroke="#c5d0e8"
            strokeWidth="10"
          />
          {PAYMENT_MIX.map((segment) => {
            const value = counts[segment.key] || 0;
            const length = total ? (value / total) * circumference : 0;
            const dashOffset = -offset;
            offset += length;
            if (!length) return null;
            return (
              <circle
                key={segment.key}
                cx="42"
                cy="42"
                r={radius}
                fill="none"
                stroke={segment.color}
                strokeWidth="10"
                strokeDasharray={`${length} ${circumference}`}
                strokeDashoffset={dashOffset}
                strokeLinecap="butt"
              />
            );
          })}
        </svg>
        <div className="invoice-mix-center">
          <div className="invoice-mix-pct">{collected}%</div>
          <div className="invoice-mix-pct-label">Paid</div>
        </div>
      </div>
      <div className="invoice-mix-legend">
        {PAYMENT_MIX.map((segment) => (
          <button
            type="button"
            key={segment.key}
            className="invoice-mix-item"
            onClick={(event) => {
              event.stopPropagation();
              onSelect?.(segment.key);
            }}
          >
            <span
              className={`invoice-status-dot invoice-status-dot-${segment.key}`}
            />
            <span>{segment.label}</span>
            <span className="invoice-mix-count">
              {counts[segment.key] || 0}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const Invioce = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "InvoiceNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  };
  const [pagination, setPagination] = useState(initialPagination);
  const [filter, setFilter] = useState(initialFilterState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  const [showCommonModal, setShowCommonModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [isSalesEmail, setIsSalesEmail] = useState(false);
  const emailUrl = `${process.env.REACT_APP_API_URL}/api/invoices/send-email/`;
  const {
    data: emailData,
    loading: emailLoading,
    error: emailError,
    postData: sentEmail,
  } = usePost(emailUrl);

  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/invoices/bulk-delete/`;
  // selectedRowKeys.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/invoices/delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/invoices/delete/${selectedRowKeys}/`);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteUrl);

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Invoice",
      href: "/invoice",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/invoices/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/invoices/`;
  const { data, loading, error, refetch } = useGet(url);

  const periodMonth = modParams.Month || dayjs().format("YYYY-MM");
  const summaryQuery = new URLSearchParams({ Month: periodMonth });
  if (modParams.OemNo) summaryQuery.set("OemNo", modParams.OemNo);
  if (modParams.DealerNo) summaryQuery.set("DealerNo", modParams.DealerNo);
  const summaryUrl = `${process.env.REACT_APP_API_URL}/api/invoices/summary/?${summaryQuery}`;
  const { data: summaryData, refetch: refetchSummary } = useGet(summaryUrl);
  const summary = summaryData?.data || {};

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onSelectChange = (newSelectedRowKeys, newSelectedRow) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/invoice/info/${record?.InvoiceNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (customFilter) => {
    const isEvent = customFilter?.nativeEvent || customFilter?._reactName;
    const filterToUse = isEvent ? filter : customFilter || filter;

    const filterDict = {};
    for (const key in filterToUse) {
      if (
        filterToUse[key] !== null &&
        filterToUse[key] !== "" &&
        filterToUse[key] !== undefined
      ) {
        if (key === "PaymentTime" || key === "InvoiceTime") {
          filterDict[key] = convertToUnix(filterToUse[key]);
        } else {
          filterDict[key] = filterToUse[key];
        }
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "InvoiceNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };

  //email functionality
  const handleEmail = () => {
    const payload = isSalesEmail
      ? { ids: selectedRowKeys, sales: true }
      : { ids: selectedRowKeys };
    sentEmail(payload);
  };

  //sent invitation
  const handleInvitation = (e) => {
    setIsModalOpen(true);
  };
  // reset
  const handleReset = (e) => {
    setFilter(initialFilterState);
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const params = {
      limit: 10,
      sort_by: "InvoiceNo",
      order: "desc",
    };
    setParams(params);
    refetch();
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.InvoiceNo,
      }));
      setListData(newData);
      refetchSummary();
    }
  }, [data, loading]);

  //toast for email
  useEffect(() => {
    if (emailError) {
      openErrorNotification(
        emailError?.response?.data?.message || "Something went wrong",
      );
    } else if (!emailLoading && !emailError && emailData) {
      openConfirmNotification("Success");

      // setTimeout(() => {
      //   navigate(-1);
      // }, 200);
    }
  }, [emailError, emailData, emailLoading]);

  const onDeleteConfirm = async () => {
    try {
      await deleteMultiple({ invoice_ids: selectedRowKeys });
      refetch();
      refetchSummary();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);

  const getExportFilterParams = () => {
    const exportParams = { ...Object.fromEntries([...params.entries()]) };
    delete exportParams.page;
    delete exportParams.limit;
    delete exportParams.pageSize;
    delete exportParams.total;
    delete exportParams.current;
    if (selectedRowKeys.length) {
      exportParams.InvoiceNos = selectedRowKeys.join(",");
    }
    return exportParams;
  };

  const fetchExportRows = async () => {
    const token = JSON.parse(sessionStorage.getItem("userData"));
    const accessToken = token?.access_token;
    const exportParams = getExportFilterParams();
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/invoices/export/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        params: exportParams,
      },
    );
    return {
      rows: response?.data?.data || [],
      filterParams: {
        ...exportParams,
        selected: selectedRowKeys.length > 0,
      },
    };
  };

  const handleSavePdf = async () => {
    try {
      setExportLoading(true);
      const { rows, filterParams } = await fetchExportRows();
      if (!rows.length) {
        openErrorNotification("No invoices found to save.");
        return;
      }
      const stamp = new Date().toISOString().slice(0, 10);
      downloadInvoiceRegisterPDF(
        rows,
        filterParams,
        `Invoice-Register_${stamp}.pdf`,
      );
      openConfirmNotification("Success");
    } catch (error) {
      openErrorNotification(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to save invoice PDF.",
      );
    } finally {
      setExportLoading(false);
    }
  };

  const handlePrintPdf = async () => {
    try {
      setExportLoading(true);
      const { rows, filterParams } = await fetchExportRows();
      if (!rows.length) {
        openErrorNotification("No invoices found to print.");
        return;
      }
      printInvoiceRegisterPDF(rows, filterParams);
      openConfirmNotification("Invoice register ready to print.");
    } catch (error) {
      openErrorNotification(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to print invoice PDF.",
      );
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
          {[1, 2, 3].includes(logData?.role_value) && (
            <CommonButton
              buttonsData={[
                {
                  label: "New Invoice",
                  icon: (
                    <VscServerProcess className="!text-[14px] font-medium" />
                  ),
                  onClick: () => {
                    navigate(`/invoice/add`);
                  },
                },
              ]}
            />
          )}
        </CommonBreadcrumb>
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <InvoiceFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          setShowEmailModal={setShowEmailModal}
          setIsSalesEmail={setIsSalesEmail}
          setShowModal={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          handleInvitation={handleInvitation}
          params={params}
          setShowCommonModal={setShowCommonModal}
          showCommonModal={showCommonModal}
          invoiceListRefecth={refetch}
          handleSavePdf={handleSavePdf}
          handlePrintPdf={handlePrintPdf}
          exportLoading={exportLoading}
        />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-4">
          <div className="invoice-metric-card">
            <div className="invoice-metric-icon">
              <FileTextFilled />
            </div>
            <div className="invoice-metric-label">Invoiced</div>
            <div className="invoice-metric-value">
              {formatMoney(summary.InvoicedAmount)}
            </div>
            <div className="invoice-metric-sub">
              {summary.InvoicedCount || 0} invoice
              {summary.InvoicedCount === 1 ? "" : "s"} ·{" "}
              {formatYearMonthToLabel(periodMonth)}
            </div>
          </div>
          <div
            className="invoice-metric-card invoice-metric-clickable"
            onClick={() => {
              if ([1, 2, 3].includes(logData?.role_value)) {
                navigate("/invoice/add");
              }
            }}
          >
            <div className="invoice-metric-icon">
              <WarningFilled />
            </div>
            <div className="invoice-metric-label">Unbilled</div>
            <div className="invoice-metric-value">
              {formatMoney(summary.UnbilledAmount)}
            </div>
            <div className="invoice-metric-sub">
              {summary.UnbilledDealerCount || 0} dealer
              {summary.UnbilledDealerCount === 1 ? "" : "s"} with orders outside
              the current invoice
            </div>
          </div>
          <div
            className="invoice-metric-card invoice-metric-clickable"
            onClick={() => {
              const nextFilter = {
                ...filter,
                PaymentStatus: "overdue",
                Month: "",
              };
              setFilter(nextFilter);
              handleFilter(nextFilter);
            }}
          >
            <div className="invoice-metric-icon">
              <ClockCircleFilled />
            </div>
            <div className="invoice-metric-label">Overdue</div>
            <div className="invoice-metric-value">
              {summary.OverdueCount || 0} invoice
              {summary.OverdueCount === 1 ? "" : "s"}
            </div>
            <div className="invoice-metric-sub">
              {summary.OverdueExample
                ? `${summary.OverdueExample.DealerName} · #${summary.OverdueExample.InvoiceNo}`
                : "No overdue invoices"}
            </div>
          </div>
          <div className="invoice-metric-card">
            <div className="invoice-metric-label">Summary</div>
            <div className="invoice-metric-sub mb-3">
              Paid vs unpaid vs overdue
            </div>
            <PaymentPerformanceCircle
              paid={summary.PaidCount || 0}
              unpaid={summary.UnpaidCount || 0}
              overdue={summary.OverdueCount || 0}
              onSelect={(status) => {
                const nextFilter = {
                  ...filter,
                  PaymentStatus: status,
                  Month: "",
                };
                setFilter(nextFilter);
                handleFilter(nextFilter);
              }}
            />
          </div>
        </div>
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          setSelectedRowKeys={setSelectedRowKeys}
          onDeleteConfirm={onDeleteConfirm}
        />
        <GlobalTable
          columns={InvoiceColumns(
            setParams,
            params,
            logData?.role_value === 1 || logData?.role_value === 3,
            logData?.role_value === 3,
          )}
          dataSource={listData?.filter(
            (item) => item.UserId !== logData.user_id,
          )}
          rowSelection={[1, 2, 3].includes(getUserRole()) ? rowSelection : null}
          pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              ...onRow?.(record, rowIndex),
            };
          }}
          loading={loading}
        />
        <ConfirmModal
          showModal={showEmailModal}
          setShowModal={setShowEmailModal}
          onDeleteConfirm={handleEmail}
          content={
            isSalesEmail
              ? "Do you want to send this email to sales?"
              : "Do you want to send this email?"
          }
        />
      </div>
    </div>
  );
};
